import BookList from "./components/BookList";
import BookFrom from "./components/BookFrom";
import { useSelector } from "react-redux";
function App() {
  const items = useSelector((state) => state.items);
  console.log(items);
  return (
    <>
      <header id="header">
        <div className="container">
          <img src="img/lws-logo.svg" alt="logo" className="logo" />
          <div className="flex items-center">
            <a className="text-white min-w-[50px] font-medium" href="#">
              Home
            </a>
            <button className="log-btn btn">Login</button>
          </div>
        </div>
      </header>
      <section>
        {/* Input Data */}
        <div className="mt-[160px] mx-4 md:mt-[160px] relative">
          <div className="bg-white rounded-md max-w-6xl w-full mx-auto">
            <BookFrom />
          </div>
        </div>
        {/* Preview Data */}
        <div className="table-container">
          <table className="booking-table">
            <thead className="bg-gray-100/50">
              <tr className="text-black text-left">
                <th>Destination From</th>
                <th>Destination To</th>
                <th className="text-center">Journey Date</th>
                <th className="text-center">Guests</th>
                <th className="text-center">Class</th>
                <th className="text-center">Delete</th>
              </tr>
            </thead>
            <tbody
              className="divide-y divide-gray-300/20"
              id="lws-previewBooked"
            >
              {items?.map((item, index) => (
                <BookList key={index} item={item} />
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}

export default App;
